export default __webpack_public_path__ + "static/services-and-resources-07c836c3812de245d5d913762dc99745.jpg";